import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [vaiTro, setVaiTro] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loiXacThuc, setLoiXacThuc] = useState("");

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser(null);
        setVaiTro(null);
        setLoading(false);
        return;
      }

      const ref = doc(db, "nguoiDung", firebaseUser.uid);
      try {
        let snap = await getDoc(ref);
        if (!snap.exists()) {
          // Tài khoản mới đăng nhập lần đầu: tự tạo hồ sơ với vai trò thấp
          // nhất, admin sẽ nâng quyền sau nếu cần (xem firestore.rules).
          await setDoc(ref, {
            hoTen: firebaseUser.email,
            email: firebaseUser.email,
            vaiTro: "nhan_vien",
          });
          snap = await getDoc(ref);
        }
        setUser(firebaseUser);
        setVaiTro(snap.data()?.vaiTro ?? "nhan_vien");
      } catch {
        // Không đọc được hồ sơ của chính mình = firestore.rules đã chặn vì
        // tài khoản bị admin vô hiệu hoá (xem taiKhoanHoatDong() trong
        // firestore.rules). Đăng xuất luôn, không giữ phiên nửa vời.
        await signOut(auth);
        setUser(null);
        setVaiTro(null);
        setLoiXacThuc("Tài khoản của bạn đã bị vô hiệu hoá. Liên hệ quản trị viên.");
      } finally {
        setLoading(false);
      }
    });
  }, []);

  // ghiNho=true (mặc định) giữ đăng nhập qua cả khi đóng trình duyệt; bỏ
  // chọn thì chỉ giữ trong phiên hiện tại, đóng tab là phải đăng nhập lại.
  const login = async (email, password, ghiNho = true) => {
    setLoiXacThuc("");
    await setPersistence(auth, ghiNho ? browserLocalPersistence : browserSessionPersistence);
    return signInWithEmailAndPassword(auth, email, password);
  };
  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, vaiTro, loading, loiXacThuc, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAuth() {
  return useContext(AuthContext);
}
